import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/shared/EventHub.js